import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { Document, Link, Page, PDFViewer, StyleSheet, Text, View } from "@react-pdf/renderer";
import { concat } from "lodash";
import moment from "moment";
import { Html } from "react-pdf-html";
import { getUrl } from "../../../utils/urls";

const ManagerReport = ({ data, type, analytic, styles }) => {
    const student = type === 'academic-report'
    const serviceRequestAttachments = data.serviceRequest?.attachments;
    const activitiesAttachments = data.activities?.map((activity) => activity?.attachments).flat()
    const records = data.attachments?.filter(attachment => attachment?.record === true);
    const processAttachments = data.attachments?.filter(attachment => attachment?.record === false);
    const hearings = data.activities?.filter(activity => activity?.type?.is_hearing)
    const related = data.related;
    const attachments = concat(processAttachments, activitiesAttachments, serviceRequestAttachments)
    return (
        <PDFViewer width={'100%'} height={'600px'}>
            <Document>
                <Page size={'A4'} orientation="portrait">
                    <View style={styles.header}>
                        <Text style={styles.title}>{`Relatório ${analytic ? 'analítico' : ''}  ${student ? "acadêmico" : "gerencial"} do atendimento ${data?.alias}`}</Text>
                        <Text style={styles.subtitle}>{`${data?.institution_branch?.institution?.name} - ${data?.institution_branch?.name}`}</Text>
                        <Text style={styles.subtitle}>{`Emitido em ${new Date().toLocaleString()}`}</Text>
                    </View>
                    <View style={styles.container}>
                        <View style={styles.column}>
                            <View style={styles.item}>
                                <Text style={{ marginBottom: '8px', backgroundColor: 'lightgray' }}> Dados do atendimento </Text>
                                <Text> Protocolo: {data.alias}  </Text>
                                {data.legal_process_code && <Text> Número do processo: {data.legal_process_code} </Text>}
                                <Text> Tipo de processo: {data.type?.type} </Text>
                                <Text> Complemento: {data.type?.name} </Text>
                            </View>

                            <View style={styles.item}>
                                <Text style={{ backgroundColor: 'lightgray' }}> Processos conexos </Text>
                                {
                                    related?.map(
                                        (process) => <Link src={`${getUrl()}/#/process-dashboard/${process.id}`}>
                                            <Text>{`Atendimento: ${process?.alias}`}</Text>
                                            <Text>{`Processo: ${process?.legal_process_code || '-'}`}</Text>

                                        </Link>
                                    )
                                }
                            </View>


                            <View style={styles.item}>
                                <Text style={{ backgroundColor: 'lightgray' }}> Íntegra do processo </Text>
                                {
                                    records && records?.map((attachment) => <Text>{attachment?.name}</Text>)
                                }
                            </View>


                            <View style={styles.item}>
                                <Text style={{ backgroundColor: 'lightgray' }}> Audiências </Text>
                                {
                                    hearings && hearings?.map(
                                        activity => <View>
                                            <Text>{activity?.type?.name}</Text>
                                            <Text>Data da audiência: {activity.conference_date ? moment(activity.conference_date).format('LLL') : 'A definir'}</Text>
                                            <Text>Tipo de audiência: {activity.hearing_type === 'p' ? 'Presencial' : activity.hearing_type === 'v' ? 'Virtual' : 'A definir'}</Text>
                                        </View>
                                    )
                                }
                            </View>

                            <View style={styles.item}>
                                <Text style={{ backgroundColor: 'lightgray' }}> Gestores </Text>
                                {data.managed_by.map(
                                    (manager) => <View style={{ marginTop: '8px' }}>
                                        <Text> Nome: {manager.user.name}</Text>
                                        <Text> Email: {manager.user.email}</Text>
                                    </View>
                                )}
                            </View>

                            <View style={styles.item}>
                                <Text style={{ marginBottom: '8px', backgroundColor: 'lightgray' }}> Cliente </Text>
                                <Text> Nome: {data.client?.name} </Text>
                                <Text> Telefone: {data.client?.phone} </Text>
                                <Text> Email: {data.client?.email} </Text>
                            </View>

                            <View style={styles.item}>
                                <Text style={{ backgroundColor: 'lightgray' }}>Partes</Text>
                                {data.parties.map((party) => <View style={{ marginTop: '8px' }}>
                                    <Text> Nome: {party.name} </Text>
                                    <Text> Email: {party.email} </Text>
                                    <Text> Telefone: {party.phone} </Text>
                                </View>)}
                            </View>

                            <View style={styles.item}>
                                <Text style={{ marginBottom: '8px', backgroundColor: 'lightgray' }}>Anexos</Text>
                                {attachments.map((attachment) => <View>
                                    <Text>{attachment?.name}</Text>
                                </View>)}
                            </View>
                        </View>

                        <View style={styles.column}>
                            {data.activities.map(
                                (activity) => <View style={styles.item}>
                                    <Text style={{ marginBottom: '8px', backgroundColor: 'lightgray' }}> {activity?.type?.name} </Text>
                                    {student && <Text> Prazo aluno: {moment(activity.deadline).format('DD/MM/YYYY')} </Text>}
                                    <Text> Prazo final: {moment(activity.effective_deadline).format('DD/MM/YYYY')} </Text>
                                    <Text> Concluída: {activity.finished ? "Sim" : "Não"} </Text>
                                    {student && <Text> Avaliada: {activity.evaluated ? "Sim" : "Não"} </Text>}
                                    {student && activity.students.length > 0 && <Text style={{ marginTop: 8, backgroundColor: 'lightgray' }}> Alunos responsáveis:</Text>}
                                    {student && activity.students.length > 0 && activity.students.map((student) => <View style={{ marginTop: '8px' }}>
                                        <Text> Nome: {student.user.name}</Text>
                                        <Text> Email: {student.user.email}</Text>
                                    </View>)}
                                    {activity.details && <Html style={{ fontSize: 10 }}>
                                        {activity.details}
                                    </Html>}
                                </View>
                            )}
                        </View>
                    </View>
                    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                        `${pageNumber} / ${totalPages}`
                    )} fixed />
                </Page>
                {analytic && (
                    <Page size={'A4'} orientation="portrait">
                        <View style={styles.body}>
                            <Text style={{ marginBottom: '8px', backgroundColor: 'lightgray', ...styles.title }}> {'Notas de atendimento'} </Text>
                            {data.notes?.map((note, index) => {
                                return <View style={{ ...styles.note, borderTop: index > 0 ? '1px solid lightgray' : '' }} key={index}>
                                    <Text> Autor: {note.author.name} </Text>
                                    <Text> Criada em: {moment(note.created_at).format('DD/MM/YYYY hh:mm')} </Text>
                                    <Html style={{ fontSize: 10, }}>
                                        {note.text}
                                    </Html>
                                </View>
                            })}
                        </View>
                        <View style={styles.body}>
                            <Text style={{ marginBottom: '8px', backgroundColor: 'lightgray', ...styles.title }}> {'Notas de movimentação'} </Text>
                            {data.activities?.map(
                                activity => {
                                    return (
                                        <View>
                                            {activity.notes?.length > 0 && <Text style={{ marginBottom: '8px', backgroundColor: 'lightgray', fontSize: 12 }}> {activity?.type?.name} </Text>}
                                            {activity.notes?.map((note, index) => {
                                                return <View style={{ ...styles.note, borderTop: index > 0 ? '1px solid lightgray' : '' }} key={index}>
                                                    <Text> Autor: {note.author?.name} </Text>
                                                    <Text> Criada em: {moment(note.created_at).format('DD/MM/YYYY hh:mm')} </Text>
                                                    <Html style={{ fontSize: 10, }}>
                                                        {note.text}
                                                    </Html>
                                                </View>
                                            })}
                                        </View>
                                    )
                                })}
                        </View>
                        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                    </Page>
                )}
            </Document>
        </PDFViewer>
    )
}


export const ReportDialog = ({ open, onClose, data, type, analytic, ...props }) => {

    const reportStyles = StyleSheet.create({
        body: {
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 35,
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            margin: '16px',
            padding: '4px',
            borderRadius: '4px',
            border: '1px solid black',
            textAlign: 'center',
        },
        title: {
            fontSize: 16,
        },
        author: {
            fontSize: 12,
            textAlign: 'center',
            marginBottom: 40,
        },
        subtitle: {
            fontSize: 10,
            marginTop: 8,
            textAlign: 'center'
        },
        text: {
            margin: 12,
            fontSize: 14,
            textAlign: 'justify',
            fontFamily: 'Times-Roman'
        },
        image: {
            marginVertical: 15,
            marginHorizontal: 100,
        },
        pageNumber: {
            position: 'absolute',
            fontSize: 12,
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: 'center',
            color: 'grey',
        },
        container: {
            display: 'flex',
            flexDirection: 'row',
        },
        column: {
            display: 'flex',
            flexDirection: 'column',
            fontSize: 12,
            width: '50%',
            marginTop: 8,
            marginLeft: 8,
            marginRight: 8
        },
        item: {
            padding: '8px',
            alignSelf: 'stretch',
            marginBottom: 10,
            fontSize: 12
        },
        note: {
            fontSize: 10,
            paddingTop: '5px',
            paddingBottom: '5px',
        }
    });

    return <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
        <DialogTitle>
            Relatório gerencial do atendimento {data?.alias}
        </DialogTitle>
        <DialogContent>
            {data && <ManagerReport data={data.data} type={data.type} analytic={data.analytic} styles={reportStyles} />}
        </DialogContent>
        <DialogActions>
            <Button startIcon={<Close />} children={'Fechar'} onClick={onClose} />
        </DialogActions>
    </Dialog>
}